import Ext from "Ext";
import AbstractDropdownButton from "./abstract_dropdown_button";
import {addClass, removeClass} from "../atBrowserUtils";

/**
 * Custom button implementation for use with dropdown menus.
 * Its toggled state is tied to the menu's displayed/hidden status.
 *
 * Default styles in:
 * <code>/css/dropdown-button.less</code>
 *
 * Depends on:
 * <code>/js/controls/abstract-dropdown-button.js</code>
 *
 * @cfg {Ext.menu.Menu} menu menu to serve as dropdown.
 */
const DropdownButton = Ext.extend(AbstractDropdownButton, {
    overCls: 'hover',
    menuAlign: "tl-bl?",
    buttonSelector: "span:first",
    menuAnchor: "td.bottom-left-cell",
    menuAlignOffset : null,
    cls: "dropdown-button",
    tooltipObject: null,
    tooltipText: null,
    tooltipEnabled: true,
    menuHideCallback: null,

    initComponent: function() {
        DropdownButton.superclass.initComponent.call(this);

        if ( !this.template ) 
            this.template = new Ext.Template(
                '<table class="' + this.cls + '" cellspacing="0" cellpadding="0" border="0" width="100%">',
                    '<tr>',
                         '<td class="top-left-border" colspan="2"></td>',
                         '<td class="top-left-cell"></td>',
                         '<td class="top-separator"></td>',
                         '<td class="top-right-cell"></td>',
                         '<td class="top-right-border" colspan="2"></td>',
                    '</tr>',
                    '<tr>',
                         '<td class="middle-left-border"></td>',
                         '<td class="middle-left-subborder"></td>',
                         '<td class="middle-left-cell contents">',
                             '<span onmouseover="Ext.getCmp(\'' + this.id + '\').showTooltip(this)" ' +
                             'onmouseout="Ext.getCmp(\'' + this.id + '\').hideTooltip(this)">{0}</span>',
                         '</td>',
                         '<td class="middle-separator"></td>',
                         '<td class="middle-right-cell"><div class="arrow"></div></td>',
                         '<td class="middle-right-subborder"></td>',
                         '<td class="middle-right-border"></td>',
                    '</tr>',
                    '<tr>',
                         '<td class="bottom-left-border" colspan="2"></td>',
                         '<td class="bottom-left-cell"></td>',
                         '<td class="bottom-separator"></td>',
                         '<td class="bottom-right-cell"></td>',
                         '<td class="bottom-right-border" colspan="2"></td>',
                    '</tr>',
               '</table>');

        this.on("menushow", function(btn) { btn.toggle(true); });
        this.on("menuhide", function(btn) { btn.toggle(false); this.handleMenuHide() }, this);
    },

    onMenuHide : function(menu)
    {
        // Reset all changes if menu is hidden without applying save
        if (this.selectorPanel && !this.selectorPanel.shouldSave) {
            this.selectorPanel.resetState(true);
        }

        DropdownButton.superclass.onMenuHide.call(this, menu);
    },

    onMenuShow : function(menu)
    {
        if (this.selectorPanel) {
            this.selectorPanel.shouldSave = !this.selectorPanel.resetOnHide;
        }

        DropdownButton.superclass.onMenuShow.call(this, menu);
    },

    handleMenuHide: function()
    {
        if ( this.menuHideCallback )
            this.menuHideCallback();
    },

    setMenuHideCallback: function ( callback )
    {
        this.menuHideCallback = callback;
    },

    setText: function(text){
        this.text = text;
        if(this.el){
            this.el.child(this.buttonSelector).update(text);
        }
        this.autoWidth();
    },

    setTooltipEnabled : function ( enabled )
    {
        this.tooltipEnabled = enabled;
    },

    setTooltipText : function ( text )
    {
        this.tooltipText = text;
    },

    showTooltip : function( element ){
        if (this.showTooltipEnabled())
        {
            var text = this.tooltipText ? this.tooltipText : this.selectorPanel.getTooltipText();
            this.doShowTooltip(text, element);
        }
    },

    doShowTooltip : function(text, element) {
        this.tooltipObject.showDelayedWithTimeout(text,
                                                  element,
                                                  0, 22, 600);
    },

    showTooltipEnabled : function() {
        return this.tooltipObject && this.tooltipEnabled;
    },

    setDisplayInputError : function ( display , message ) {
        if( !this.el )
            return;
        var parent = this.el.dom.parentNode;
        var errorElement = parent ? parent : this.el.dom;
        if (display)
            addClass( errorElement, this.errorCls );
        else
            removeClass( errorElement, this.errorCls );
        this.setTooltipEnabled( display );
        this.setTooltipText( message );
    },

    hideTooltip : function(){
        if ( this.tooltipObject )
            this.tooltipObject.cancelDelayedShow();
    },

    afterRender: function() {
        DropdownButton.superclass.afterRender.call(this);
    },

    showMenu : function(){
        if(this.menu){
            this.menu.show(this.el.child(this.menuAnchor), this.menuAlign);
        }
        return this;
    }

});

Ext.reg('at_dropdown_button', DropdownButton);

export default DropdownButton;


// WEBPACK FOOTER //
// ./web/js/controls/at_dropdown_button.js